<div class='container-float'>

  <b-alert 
    v-model="showAlertAcceptance" 
    variant="warning" 
    dismissible
    class="custom-alert"
  >
    Per registrarsi è necessario marcare la casella di accettazione termini e condizioni
  </b-alert>
  <b-alert 
    v-model="showAlertRegistration" 
    variant="success" 
    dismissible
    class="custom-alert"
  >
    E' stata inviata una email con il codice di registrazione da inserire nella casella in fondo e poi si deve confermare con il bottone
  </b-alert>

  <b-alert 
    v-model="showAlertConfirmationError" 
    variant="success" 
    dismissible
    class="custom-alert"
  >
    Il codice inviato non risulta essere corrispondente. Ricontrollare che sia quello contenuto nella email
  </b-alert>

  <b-alert 
    v-model="showAlertGenericError" 
    variant="success" 
    dismissible
    class="custom-danger"
  >
    {{ exception }}
  </b-alert>

  <b-row>
    <b-col cols="7">
      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="2">
          <img src="@/assets/imgs/logo.jpg" style='width: 10rem;margin-left: 1.5rem;'>
        </b-col>
        <b-col cols="3">
          <h3 style="margin-top: 7rem;font-weight: 600;">&nbsp;Listino prezzi</h3>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col cols="12">
          &nbsp;
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="8">
          <h5 style="margin-left: -2.0em;">Sei un nuovo utente? Registrati ora in meno di un minuto</h5>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="2">
          <p>Nome</p>
        </b-col>
        <b-col cols="6">
          &nbsp;
        </b-col>
      </b-row>        
      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="7">
          <b-form-input v-model="name" placeholder="Inserisci il tuo nome" style="margin-left: 2.7rem;"></b-form-input>
        </b-col>
        <b-col cols="1">
          &nbsp;
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="2">
          <p>Email</p>
        </b-col>
        <b-col cols="6">
          &nbsp;
        </b-col>
      </b-row>        
      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="7">
          <b-form-input v-model="email" placeholder="Inserisci la tua email" style="margin-left: 2.7rem;"></b-form-input>
        </b-col>
        <b-col cols="1">
          &nbsp;
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="2">
          <p>Login</p>
        </b-col>
        <b-col cols="6">
          &nbsp;
        </b-col>
      </b-row>        
      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="7">
          <b-form-input v-model="login" placeholder="Inserisci la tua login" style="margin-left: 2.7rem;"></b-form-input>
        </b-col>
        <b-col cols="1">
          &nbsp;
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="2">
          <p>Password</p>
        </b-col>
        <b-col cols="6">
          &nbsp;
        </b-col>
      </b-row>        
      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="7">
          <b-form-input type="password" v-model="password" placeholder="Inserisci la tua password" style="margin-left: 2.7rem;"></b-form-input>
        </b-col>
        <b-col cols="1">
          &nbsp;
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="4">
          <b-form-checkbox v-model="acceptance" style="margin-left: -1.2rem;">&nbsp;Accetto i termini e le condizioni</b-form-checkbox>
        </b-col>
        <b-col cols="4">
          &nbsp;
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="7">
          <b-button @click="execute_register" variant="primary" style="width: 100%;margin-left: 2.3rem;">Registrati</b-button>
        </b-col>
        <b-col cols="1">
          &nbsp;
        </b-col>
      </b-row>

      <b-row class="mb-3" v-if="registration_executed">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="5">
          <b-form-input v-model="confirmation_code" placeholder="Inserisci il codice di conferma ricevuto in mail" style="margin-left: 2.7rem;"></b-form-input>
        </b-col>
        <b-col cols="2">
          <b-button @click="execute_confirm" variant="primary" style="width: 100%;margin-left: 2.3rem;">Conferma</b-button>
        </b-col>
        <b-col cols="1">
          &nbsp;
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="7">
          <p @click="goto_login">Hai già un account? &nbsp;<span style="font-weight: 600;color: darkred;cursor: pointer;">Vai alla Login</span></p>
        </b-col>
        <b-col cols="1">
          &nbsp;
        </b-col>
      </b-row>
    </b-col>

  </b-row>

</div>